<p-dialog
        [(visible)]="visible"
        [modal]="true"
        header="Select Sample Categories"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-table
                [value]="categories"
                [(selection)]="selectedCategories"
                dataKey="id"
                [tableStyle]="{'min-width': '50rem'}"
                selectionMode="multiple"
                scrollable="true"
                scrollHeight="300px"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Name</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-category>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="category"></p-tableCheckbox>
                    </td>
                    <td>{{ category.name }}</td>
                </tr>
            </ng-template>
        </p-table>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" (click)="close()" severity="secondary"></p-button>
            <p-button label="Save" (click)="save()" [loading]="saving"></p-button>
        </div>
    </div>
</p-dialog>
